import React from 'react';
import { typography } from '../../styles/design-tokens';

export const DisciplineTabSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 w-full mb-16">
      {/* Header Skeleton */}
      <div className="flex flex-wrap justify-between items-center">
        <div className="h-8 w-64 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="h-10 w-36 bg-gray-200 rounded-md animate-pulse"></div>
      </div>

      {/* Metrics Grid Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 min-[1165px]:grid-cols-4 gap-4">
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-xl border border-[#E4E8EA] animate-pulse"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="flex items-center mb-2">
              <div className="w-8 h-8 rounded-full bg-gray-200 mr-3"></div>
              <div className="h-5 w-24 bg-gray-200 rounded"></div>
            </div>
            <div className="h-8 w-16 bg-gray-100 rounded mt-2"></div>
          </div>
        ))}
      </div>

      {/* Records Skeleton */}
      <div className="bg-white rounded-2xl p-6 border border-[#E4E8EA]">
        <div className="flex justify-between items-center mb-6">
          <div className="h-6 w-48 bg-gray-200 rounded-md animate-pulse"></div>
        </div>

        <div className="space-y-4">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="border border-[#E4E8EA] rounded-xl p-4 animate-pulse"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex justify-between items-start mb-3">
                <div className="space-y-2">
                  <div className="h-5 w-32 bg-gray-200 rounded"></div>
                  <div className="h-4 w-48 bg-gray-100 rounded"></div>
                </div>
                <div className="h-8 w-24 bg-gray-200 rounded-md"></div>
              </div>

              <div className="h-4 w-full bg-gray-100 rounded my-3"></div>

              <div className="flex items-center justify-between mt-4">
                <div className="h-5 w-24 bg-gray-200 rounded"></div>
                <div className="flex space-x-2">
                  <div className="h-8 w-8 rounded-full bg-gray-200"></div>
                  <div className="h-8 w-8 rounded-full bg-gray-200"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
